<script setup lang="ts">
import ContestModalPreview from './ContestModalPreview.vue'

import contestTexts from '@/views/contests/texts.json'
import { createNewReward } from '@/views/contests/utils'

import type { ContestMechanic } from '@/types/global'
import type { TemplateDetailContests } from '@/types/types'

const props = defineProps<{ mechanic?: ContestMechanic }>()

const { t } = useI18n()
const { merchantName } = useLocalStorage()

const PREVIEW_REWARD_PROBABILITY = 25
const PREVIEW_REWARDS: { type: string; nameKey?: string }[] = [
  { type: 'gift', nameKey: 'pages.contests.mechanics.preview.coffee' },
  { type: 'gift', nameKey: 'pages.contests.mechanics.preview.croissant' },
  { type: 'points' }
]

type PreviewDetail = TemplateDetailContests & { mechanic: ContestMechanic; callToActionText: string }

const buildMechanicDetail = (mechanic: ContestMechanic): PreviewDetail => {
  const wording = contestTexts[mechanic]
  const colors = { color: '#FFFFFF', textColor: '#111111' }

  return {
    mechanic,
    contestGameRewards: PREVIEW_REWARDS.map(({ type, nameKey }, index) => ({
      ...createNewReward({ type, index, colors, t }),
      probability: PREVIEW_REWARD_PROBABILITY,
      ...(nameKey ? { name: t(nameKey) } : {})
    })),
    title: wording.title,
    subtitle: wording.subtitle,
    callToActionText: wording.callToActionText,
    canLose: true,
    losingProbability: PREVIEW_REWARD_PROBABILITY,
    losingTileText: t('pages.contests.contestsCreatePage.preview.losingTileText'),
    formTitle: wording.formTitle,
    formSubtitle: wording.formSubtitle,
    formSubmitButtonText: wording.formSubmitButtonText,
    optinText: t('pages.contests.contestsCreatePage.preview.optinText', { merchantName: merchantName.value })
  }
}

const detailContests = computed(() => (props.mechanic ? buildMechanicDetail(props.mechanic) : undefined))
</script>

<template>
  <div class="flex h-full flex-col items-center justify-start gap-3">
    <template v-if="detailContests">
      <div class="h-[640px] w-[356px] max-w-full overflow-hidden px-2 pt-1 lg:h-full">
        <ContestModalPreview :key="detailContests.mechanic" :detail-contests="detailContests" />
      </div>
    </template>

    <p v-else class="my-auto max-w-[220px] pb-4 text-center text-sm text-foreground-secondary">
      {{ t('pages.contests.mechanics.preview.empty') }}
    </p>
  </div>
</template>
